import React from 'react';

const Error = ({mensaje}) => ( 

  <p className="error">{mensaje}</p>

);
 
export default Error;